import { Grid, styled } from "@mui/material";
import React from "react";
interface MxCPropertyContentHeaderProp {
  children: any;
  onClick?: () => void;
}

const MxCPropertyContentHeader = (props: MxCPropertyContentHeaderProp) => {
  return <Content {...props} />;
};

export default MxCPropertyContentHeader;

const Content = styled(Grid)(({ theme }) => ({
  position: "relative",
  "&:hover .checkbox-container .MuiButtonBase-root": {
    display: "flex"
  }
}));
